import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=15acb65a&"
import script from "./BreadCrumb.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumb.vue?vue&type=script&lang=ts&"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports